import React, { Component } from "react"
import * as htmlHelper from "../../helpers/html"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"

export default class SimpleModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: props.modalOpen,
      modalData: props.modalData,
    }
  }

  render() {
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal">
          <OutsideClickTrigger
            onOutsideClick={() => {
              this.props.closeHandler()
            }}
          >
            <React.Fragment>
              <button
                className="button button--icon js--close-modal"
                onClick={() => {
                  this.props.closeHandler()
                }}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content__inner">
                <div className="modal__top">
                  <div className="a--left">
                    {this.state.modalData.h3 ? (
                      <h3 className="headline-md"> {htmlHelper.htmlStringToReactElement(this.state.modalData.h3)}</h3>
                    ) : null}
                    {this.state.modalData.richText ? (
                      <div className="rich-text">{htmlHelper.htmlStringToReactElement(this.state.modalData.richText)}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}
